export const formatStatisticalNumberOutput = (number) => {
    if (number < 100) {
        return number;
    }

    return '99+';
};

export const getStatePropertyItemsCount = (items) => {
    if (typeof items !== 'undefined') {
        return items.length;
    }

    return 0;
};
